import Constants from "./Constants";

const PATH_STEPS_NEW = [
  Constants.VIEW_CHOOSE_SETUP_TYPE,
  Constants.VIEW_PREFERRED_DOMAIN,
  Constants.VIEW_CONFIRM,
  Constants.VIEW_COMPLETE,
];

const PATH_STEPS_MIGRATE = [
  Constants.VIEW_CHOOSE_SETUP_TYPE,
  Constants.VIEW_PREFERRED_DOMAIN,
  Constants.VIEW_CURRENT_BLOG_DOMAIN,
  Constants.VIEW_CURRENT_BLOG_LOGIN,
  Constants.VIEW_CONFIRM,
  Constants.VIEW_COMPLETE,
];

const PathMap = {};
PathMap[Constants.PATH_MIGRATION] = PATH_STEPS_MIGRATE;
PathMap[Constants.PATH_NEW] = PATH_STEPS_NEW;
PathMap[Constants.PATH_NEW_UPDATE] = [...PATH_STEPS_NEW].splice(2);
PathMap[Constants.PATH_NEW_UPDATE].unshift(Constants.VIEW_UPDATE_START);

PathMap[Constants.PATH_MIGRATION_UPDATE] = [...PATH_STEPS_MIGRATE].splice(2);
PathMap[Constants.PATH_MIGRATION_UPDATE].unshift(Constants.VIEW_UPDATE_START);

export default PathMap;
